<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">订单详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <div class="contentTop">
                    <img src="../../assets/images/success.png" alt="">
                    <span>充值成功</span>
                    <div><span>¥500.00</span></div>                    
                    <span>2018年8月2日  15:26</span>
                </div>
                <div class="contentMain">
                    <div class="shopTitle">上林时光（长街店）</div>
                    <div class="leftContent">
                        <span>会员卡号</span>
                        <span>支付方式</span>
                        <span>充值赠送</span>
                        <span>原有余额</span>
                        <span>现有余额</span>
                        <span>交易时间</span>
                        <span>订单号</span>
                    </div>
                    <div class="rightContent">
                        <span>SLSG 1083 4791 656</span>
                        <span>现金</span>
                        <span>¥10.00</span>
                        <span>¥63.00</span>
                        <span>¥573.00</span>
                        <span>2018年8月2日  15:26</span>
                        <span>20180324100101001897</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem } from 'mint-ui';
export default {
  data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1'   
    };
  },
  computed: {},
  components: {},
  methods: {     
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
  background-color: #ffffff;  
}
.contentTop{
    width: 9.24rem;
    height: 4.74rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.2);
    margin-left: 0.39rem;
    position: relative;
}
.contentTop :nth-child(1){
    width: 1.84rem;
    height: 1.84rem;
    position: absolute;
    top: 0.39rem;
    left: 3.6rem;
}
.contentTop :nth-child(2){
    font-size: 0.53rem;
    font-weight: 600;
    color: #299EAD;
    position: absolute;
    top: 2.61rem;
    left: 3.45rem;
}
.contentTop :nth-child(3){
    font-size: 0.53rem;
    color: rgba(16, 16, 16, 0.54);
    position: absolute;
    top: 3.53rem;
    left: 3.35rem;
}
.contentTop :nth-child(3) :only-child{
    font-size: 0.53rem;
    font-weight: 600;
    text-align: center;
    position: absolute;
    top: 0rem;
    left: 0.2rem;
}
.contentTop :nth-child(4){
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 4.26rem;
    left: 3rem;
}
.contentMain{
    height: 7.84rem;
    width: 100%;
}
.shopTitle{
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
    position: relative;
    top: 0.39rem;
    left: 3.03rem;
}
.leftContent{
    width: 50%;
    height: 100%;
    float: left;
    position: relative;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.rightContent{
    width: 50%;
    height: 100%;
    float: right;
    position: relative;
    right: 0rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.leftContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    left: 0.53rem;
}
.leftContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    left: 0.53rem;
}
.leftContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    left: 0.53rem;
}
.leftContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    left: 0.53rem;
}
.leftContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    left: 0.53rem;
}
.leftContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    left: 0.53rem;
}
.leftContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    left: 0.53rem;
}
.rightContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    right: 0.37rem;
}
.rightContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    right: 0.37rem;
}
.rightContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    right: 0.37rem;
}
.rightContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    right: 0.37rem;
}
.rightContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    right: 0.37rem;
}
.rightContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    right: 0.37rem;
}
.rightContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    right: 0.37rem;
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/chargeDetail.vue